import React, { FC } from 'react'
import classNames from 'classnames'
import styled from '@emotion/styled'

enum IconDashboardSizeEnum {
  BIG = 'big'
}
interface IIconDashboard {
  style?: Record<string, unknown>
  size?: IconDashboardSizeEnum
}

const IconDashboardWrapper = styled.div`
  color: white;
  font-size: 22px;
  margin-right: 12px;
  line-height: 12px;
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
`

export function IconDashboardSvg() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="7.5" fillOpacity="0" stroke="currentColor" />
      <circle cx="8" cy="8" r="3.5" fill="currentColor" />
    </svg>
  )
}

export const IconDashboard: FC<IIconDashboard> = (props) => {
  return (
    <IconDashboardWrapper
      className={classNames('icon IconDashboard', props.size)}
      style={props.style}
      role="img"
      aria-label="Icon Dashboard"
    >
      <IconDashboardSvg />
    </IconDashboardWrapper>
  )
}

export default IconDashboard
